import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wave-left"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6.3304 15.9222C5.78926 15.3811 5.78926 14.5037 6.3304 13.9626C6.87155 13.4214 7.74891 13.4214 8.29005 13.9626L6.20527 11.8778C5.66335 11.3359 5.66335 10.4573 6.20527 9.91534C6.74718 9.37342 7.62581 9.37342 8.16772 9.91534L6.80091 8.54852C6.25899 8.0066 6.25899 7.12798 6.80091 6.58607C7.34283 6.04415 8.22145 6.04415 8.76337 6.58607L10.1302 7.95288C9.58826 7.41096 9.58826 6.53234 10.1302 5.99042C10.6721 5.4485 11.5507 5.44851 12.0926 5.99042L17.5628 11.4606C17.5637 11.4615 17.5637 11.4591 17.5634 11.4579L16.8947 8.96228C16.7709 8.50016 16.9473 8.00975 17.3371 7.7324C17.8856 7.34213 18.6509 7.50679 18.9904 8.08814L21.2166 11.9005C22.6351 14.3295 22.2373 17.4094 20.2484 19.3984L19.4041 20.2427C16.9869 22.6598 13.068 22.6598 10.6508 20.2427L6.3304 15.9222Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.29005 13.9626L10.7348 16.4073M8.29005 13.9626L6.20527 11.8778C5.66335 11.3359 5.66335 10.4573 6.20527 9.91534C6.74718 9.37342 7.62581 9.37342 8.16772 9.91534M8.29005 13.9626C7.74891 13.4214 6.87155 13.4214 6.3304 13.9626C5.78926 14.5037 5.78926 15.3811 6.3304 15.9222L10.6508 20.2427C13.068 22.6598 16.9869 22.6598 19.4041 20.2427L20.2484 19.3984C22.2373 17.4094 22.6351 14.3295 21.2166 11.9005L18.9904 8.08814C18.6509 7.50679 17.8856 7.34213 17.3371 7.7324C16.9473 8.00975 16.7709 8.50016 16.8947 8.96228L17.5622 11.4534C17.5628 11.4559 17.5611 11.4589 17.5593 11.4571L12.0926 5.99042C11.5507 5.44851 10.6721 5.4485 10.1302 5.99042C9.58826 6.53234 9.58826 7.41096 10.1302 7.95288M8.16772 9.91534L12.6972 14.4449M8.16772 9.91534L6.80091 8.54852C6.25899 8.0066 6.25899 7.12798 6.80091 6.58607C7.34283 6.04415 8.22145 6.04415 8.76337 6.58607L10.1302 7.95288M10.1302 7.95288L14.6597 12.4824","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2.86621 5.58521C3.62869 4.479 4.58845 3.51927 5.69469 2.75684","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WaveLeft = Vue.extend<IconProps>({
  name: 'WaveLeftIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wave-left',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WaveLeft;
